import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { helpers } from '../helpers';
import { CountUp } from 'countup.js';
import { parallaxAnim, summaryAnim } from '../animations';
import loadVideos from '../videos';

gsap.registerPlugin(ScrollTrigger);

const countStart = () => {
    const elem = document.querySelector('.count-up');

    if (!elem) {
        return;
    }

    const value = elem.dataset.value;
    const counter = new CountUp(elem, value, {
        startVal: 100000,
        useEasing: true,
        useGrouping: true,
        duration: 2,
        separator: ',',
    });

    counter.start();
};

const phoneGridAnim = () => {
    const nest = document.querySelector('.phones-grid');
    const portrait = document.querySelectorAll('.phones-grid .frame--portrait');
    const landscape = document.querySelectorAll('.phones-grid .frame--landscape');
    const distance = helpers.isPhone() ? 400 : 600;

    portrait.forEach((phone) => {
        const amount = phone.dataset.parallax;

        gsap.from(phone, {
            y: amount,
            ease: 'none',
            scrollTrigger: {
                trigger: nest,
                start: 'top bottom',
                end: `top center-=${distance}`,
                scrub: true,
            },
        });
    });

    landscape.forEach((phone) => {
        const amount = phone.dataset.parallax;

        gsap.from(phone, {
            x: amount,
            ease: 'none',
            scrollTrigger: {
                trigger: nest,
                start: 'top center',
                end: `top center-=${distance}`,
                scrub: true,
            },
        });
    });
};

const notesAnim = () => {
    const nest = document.querySelectorAll('.notes');
    const notes = document.querySelectorAll('.notes__item');

    notes.forEach((note, i) => {
        if (helpers.isPhone()) {
            const offset = note.offsetTop;

            gsap.from(note, {
                y: 200,
                ease: 'none',
                scrollTrigger: {
                    trigger: nest,
                    start: `top bottom`,
                    end: `top center-=${offset}`,
                    scrub: true,
                },
            });
        } else {
            gsap.from(note, {
                scale: 0.8,
                alpha: 0,
                ease: 'none',
                scrollTrigger: {
                    trigger: note,
                    start: `bottom bottom+=100`,
                    end: `top center+=100`,
                    scrub: true,
                },
            });
        }
    });
};

const collageAnim = () => {
    const nest = document.querySelector('.collage-2');
    const images = document.querySelectorAll('.collage-2__item');

    images.forEach((image) => {
        const amount = image.dataset.parallax;

        gsap.from(image, {
            x: amount,
            alpha: 0.2,
            ease: 'none',
            scrollTrigger: {
                trigger: nest,
                start: 'top bottom',
                end: 'top center-=100',
                scrub: true,
            },
        });
    });
};

const headerAnim = () => {
    const nest = document.querySelector('.text__header-slide');
    const headers = document.querySelectorAll('.text__header-slide h2');

    headers.forEach((header, i) => {
        const offset = helpers.isPhone() ? 60 : 150;

        gsap.from(header, {
            y: helpers.isPhone() ? 100 : 200,
            ease: 'none',
            scrollTrigger: {
                trigger: nest,
                start: `top bottom`,
                end: `top bottom-=${(i + 1) * offset}`,
                scrub: true,
            },
        });
    });
};

const carouselAnim = () => {
    const elems = document.querySelectorAll('.carousel');

    elems.forEach((elem) => {
        helpers.waitForElem(elem, '.slider').then((slider) => {
            ScrollTrigger.create({
                trigger: slider,
                start: 'top center+=200',
                onEnter: () => {
                    slider.classList.add('open');
                },
            });
        });
    });
};

const bonusAnim = () => {
    const portrait = document.querySelectorAll('.bonus .frame');

    portrait.forEach((iphone) => {
        gsap.from(iphone, {
            y: 160,
            ease: 'none',
            scrollTrigger: {
                trigger: iphone,
                start: 'top bottom',
                end: 'top center',
                scrub: true,
            },
        });
    });
};

(function () {
    countStart();
    phoneGridAnim();
    notesAnim();
    collageAnim();
    headerAnim();
    carouselAnim();
    loadVideos();
    parallaxAnim();
    bonusAnim();
})();

window.addEventListener('load', () => {
    summaryAnim();
});
